module.exports = __webpack_public_path__ + "static/media/Bubbles.672f00cb.png";